import { useNavigate } from "react-router-dom";

export default function BusinessEntry() {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1 rounded-full bg-red-50 text-red-600 text-xs font-semibold tracking-widest uppercase mb-4">
            Join Us
          </span>
          <h2
            className="text-3xl md:text-4xl font-black text-gray-900 mb-3"
            style={{ fontFamily: "'Noto Serif TC', serif" }}
          >
            更多合作機會
          </h2>
          <p className="text-gray-500 text-sm max-w-md mx-auto">
            無論是品牌合作還是個人發展，我們都有你的舞台
          </p>
        </div>

        {/* Two Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Business Card */}
          <div className="relative rounded-3xl overflow-hidden group cursor-pointer" onClick={() => navigate("/business")} style={{ minHeight: "420px" }}>
            <img
              src="https://public.readdy.ai/ai/img_res/495a15bd9e5dba3aa70cf456508e7c3a.jpg"
              alt="工商合作"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/10" />
            <div className="absolute inset-0 flex flex-col justify-end p-8">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-600/90 text-white text-xs font-semibold mb-4 w-fit">
                <i className="ri-star-fill text-yellow-300" />
                Business
              </div>
              <h3
                className="text-3xl md:text-4xl font-black text-white mb-3"
                style={{ fontFamily: "'Noto Serif TC', serif" }}
              >
                工商合作
              </h3>
              <p className="text-white/80 text-sm leading-relaxed mb-5 max-w-sm">
                直播、展場、SG、舞團、網紅業配、活動策劃、攝影紀錄……<br />
                私訊 IG 或填表單，打造你的品牌曝光舞台。
              </p>
              {/* Service tags */}
              <div className="flex flex-wrap gap-2 mb-6">
                {["直播合作", "展場活動", "網紅業配", "活動策劃", "攝影紀錄"].map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 rounded-full bg-white/20 text-white text-xs font-medium backdrop-blur-sm"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <button
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-gray-900 font-bold text-sm hover:bg-red-600 hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap w-fit"
                onClick={(e) => { e.stopPropagation(); navigate("/business"); }}
              >
                <i className="ri-briefcase-4-line" />
                了解合作項目
                <i className="ri-arrow-right-line" />
              </button>
            </div>
          </div>

          {/* Recruit Card */}
          <div className="relative rounded-3xl overflow-hidden group cursor-pointer" onClick={() => navigate("/recruit")} style={{ minHeight: "420px" }}>
            <img
              src="https://readdy.ai/api/search-image?query=live%20streamer%20young%20talented%20performer%20microphone%20spotlight%20stage%20entertainment%20singing%20dancing%20charismatic%20influencer%20Taiwan%20vibrant%20colorful%20energy&width=800&height=600&seq=entry-recruit-01&orientation=landscape"
              alt="直播主招募"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/10" />
            <div className="absolute inset-0 flex flex-col justify-end p-8">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-600/90 text-white text-xs font-semibold mb-4 w-fit">
                <i className="ri-live-line text-yellow-300" />
                Now Recruiting
              </div>
              <h3
                className="text-3xl md:text-4xl font-black text-white mb-3"
                style={{ fontFamily: "'Noto Serif TC', serif" }}
              >
                直播主招募
              </h3>
              <p className="text-white/80 text-sm leading-relaxed mb-5 max-w-sm">
                別讓朝九晚五限制你的才華！在 17LIVE / 浪LIVE，你就是自己的老闆。<br />
                零經驗也能上手，專業培訓 + 流量扶持。
              </p>
              {/* Perks */}
              <div className="flex flex-wrap gap-2 mb-6">
                {["零經驗歡迎", "形象攝影", "直播培訓", "流量扶持", "彈性時間"].map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 rounded-full bg-white/20 text-white text-xs font-medium backdrop-blur-sm"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <button
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-red-600 text-white font-bold text-sm hover:bg-white hover:text-gray-900 transition-all duration-200 cursor-pointer whitespace-nowrap w-fit"
                onClick={(e) => { e.stopPropagation(); navigate("/recruit"); }}
              >
                <i className="ri-user-add-line" />
                立即應徵直播主
                <i className="ri-arrow-right-line" />
              </button>
            </div>
          </div>
        </div>

        {/* Bottom strip */}
        <div className="mt-8 rounded-2xl bg-stone-50 border border-stone-100 px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-100 text-red-600">
              <i className="ri-instagram-line text-lg" />
            </div>
            <div>
              <p className="text-gray-900 font-semibold text-sm">有任何合作或應徵想法？</p>
              <p className="text-gray-400 text-xs">私訊我們的 Instagram 最快速！</p>
            </div>
          </div>
          <a
            href="https://www.instagram.com/rappy.meme/"
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-red-600 text-white text-sm font-semibold hover:bg-red-700 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-instagram-line" />
            @rappy.meme
          </a>
        </div>
      </div>
    </section>
  );
}
